import { AxiosError } from 'axios';
import { DetectedObjectTypes } from 'types';
import { HcsAPI } from '..';
import { formatAxiosError } from '../api-error-handler';
import dataExtractionDefinitionsMapper from './mapper';

const getDataExtractionDefinitions = async (): Promise<DetectedObjectTypes> => {
  try {
    const { data } = await HcsAPI.get<Record<number, string>>(`dataExtractionDefinitions`);
    return dataExtractionDefinitionsMapper(data);
  } catch (error) {
    const axiosError = error as AxiosError;
    throw formatAxiosError(
      axiosError,
      'An error has occured while retrieving data extraction enums.',
    );
  }
};

export default {
  getDataExtractionDefinitions,
};
